export default __webpack_public_path__ + "static/media/classesScheduled.812725bc.svg";